// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import {useState, useEffect, useContext} from 'react';
// @ts-ignore
import storage from '/util/storage';
import {App_context} from 'hola_app_context';

export const use_hidden = (is_client_prop?: boolean)=>{
    let val = is_client_prop ? [] : storage.get_json('www_hidden')||[];
    if (!Array.isArray(val))
        val = [];
    const {is_client} = useContext(App_context);
    const [hidden, set_hidden] = useState(val);
    const hide = name=>{
        const new_val = hidden.includes(name) ? hidden : [...hidden, name];
        storage.set_json('www_hidden', new_val);
        set_hidden(new_val);
    };
    useEffect(()=>{
        if (is_client_prop && is_client)
        {
            let _val =
                is_client_prop ? [] : storage.get_json('www_hidden')||[];
            if (!Array.isArray(_val))
                _val = [];
            set_hidden(_val);
        }
    }, [is_client]);
    return [hidden, hide];
};
